<div class="user-pp" >{{ user?.initiales }}</div>

<div class="d-flex flex-column fit-content ps-4 d-none d-md-flex">
  <div class="fit-content" [title]="user?.displayName">
    <p class="fw-semibold text-truncate mb-0 ps-0">{{ user?.displayName }}</p>
  </div>
  <div class="fit-content" [title]="user?.accesApplicatif?.[0]?.nomProfil">
    <p class="text-truncate mb-0 ps-0">{{ user?.accesApplicatif?.[0]?.nomProfil }}</p>
  </div>
  <div class="fit-content">
    <div (click)="logOut()" class="user-disconnect mb-0 ps-0">Déconnexion</div>
  </div>
</div>
